"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("preact/jsx-runtime");
const hooks_1 = require("preact/hooks");
const hooks_2 = require("../hooks");
const styles = {
    container: {
        borderRadius: '5%',
        backgroundColor: 'rgba(0,0,0,.7)',
        color: 'white',
        padding: '5px 10px',
        margin: 0,
        maxWidth: 400
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    title: {
        margin: 0,
        overflow: 'hidden'
    },
    description: {
        margin: 0,
        marginTop: 10
    },
    button: {
        backgroundColor: 'transparent',
        color: 'white',
        borderRadius: '15%',
        borderStyle: 'outset',
        padding: '2px 5px'
    },
    editContainer: {
        marginTop: 10,
        display: 'flex',
        justifyContent: 'center'
    }
};
const InfoElement = ({ title, description, isEdit, sanitized, id }) => {
    const [isOpen, toggleIsOpen] = (0, hooks_2.useToggle)(false);
    const elementRef = (0, hooks_1.useRef)(null);
    const onClickContainer = (0, hooks_1.useCallback)(() => {
        if (isOpen === false) {
            toggleIsOpen(true);
            dispatchEvent('TOGGLE_INFO_ELEMENT');
        }
    }, []);
    const contentProps = (0, hooks_1.useMemo)(() => {
        let props;
        if (sanitized) {
            props = {
                dangerouslySetInnerHTML: { __html: description }
            };
        }
        else {
            props = { children: description };
        }
        return props;
    }, [sanitized, description]);
    const dispatchEvent = (0, hooks_1.useCallback)((eventName, data) => {
        const event = new CustomEvent(eventName, { bubbles: true, detail: Object.assign({ id }, data) });
        elementRef.current.dispatchEvent(event);
    }, [elementRef.current, id]);
    const onClickClose = (0, hooks_1.useCallback)((e) => {
        e.stopPropagation();
        toggleIsOpen(false);
        dispatchEvent('TOGGLE_INFO_ELEMENT');
    }, []);
    const saveElement = (0, hooks_1.useCallback)((e) => {
        e.stopPropagation();
        const container = elementRef.current;
        const title = container.querySelector('h4').textContent;
        const description = container.querySelector('p').textContent;
        toggleIsOpen(false);
        dispatchEvent('UPDATE_INFO_ELEMENT', { title, description });
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: elementRef, style: styles.container, onClick: onClickContainer }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ style: styles.titleContainer }, { children: [(0, jsx_runtime_1.jsx)("h4", Object.assign({ contentEditable: isOpen && isEdit, style: styles.title }, { children: title })), isOpen && (0, jsx_runtime_1.jsx)("button", Object.assign({ style: styles.button, onClick: onClickClose }, { children: "X" }))] })), (0, jsx_runtime_1.jsx)("p", Object.assign({ contentEditable: isEdit, style: Object.assign(Object.assign({}, styles.description), { display: isOpen ? 'block' : 'none' }) }, contentProps)), isEdit && isOpen && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: styles.editContainer }, { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: saveElement, style: styles.button }, { children: "Guardar" })), "\u00A0", (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => dispatchEvent('DELETE_INFO_ELEMENT'), style: styles.button }, { children: "Borrar" }))] })))] })));
};
exports.default = InfoElement;
